import React from "react";
import { Plus } from "lucide-react";
import type SceneGroupTreeViewModel from "../../modelTreeViews/SceneGroupTreeviewModel";

/** Fixed creation actions belong to the split navigator, independently of its current pin. */
export default function NavigatorHeaderMenu({
  kind,
}: {
  kind:
    | "scenes" // no itx
    | "cabinets"; // no itx
}) {
  const addScene = (type: "Scene" | "Multiplexer") => {
    (state.sceneGroup.treeViewModel as SceneGroupTreeViewModel).createItem(type);
    state.undoManager.userInteractionEnded();
  };
  const actions =
    kind === "scenes"
      ? [
          { id: "scene", label: "Szene hinzufügen", image: "/images/various/scene.png", run: () => addScene("Scene") },
          {
            id: "multiplexer",
            label: "Multiplexer hinzufügen",
            image: "/images/various/multiplexer.png",
            run: () => addScene("Multiplexer"),
          },
        ]
      : [
          {
            id: "cabinet",
            label: "Schaltschrank hinzufügen",
            image: state.cabinets.treeViewModel.iconUrl,
            run: () => state.cabinets.treeViewModel.handleAdd(),
          },
        ];
  return (
    <div className="navigatorHeaderMenu" role="group" aria-label="Hinzufügen">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className="navigatorHeaderAction"
          data-testid={`navigator-add-${action.id}`}
          title={action.label}
          aria-label={action.label}
          onClick={action.run}
        >
          <img src={action.image} alt="" draggable={false} />
          <Plus size={13} className="navigatorHeaderActionPlus" />
        </button>
      ))}
    </div>
  );
}
